import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "evrideo-ag-grid-evrideo-progress-wheel",
  templateUrl: "./ag-grid-evrideo-progress-wheel.component.html",
  styleUrl: "./ag-grid-evrideo-progress-wheel.component.scss",
})
export class AgGridEvrideoProgressWheelComponent implements OnChanges {
  @Input() progress: number = 0;
  circleProgress: string = "";

  circumference = 2 * Math.PI * 9; // 2πr
  dashOffset = this.circumference;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["progress"]) {
      this.updateProgress();
    }
  }

  private updateProgress(): void {
    const p = this.progress < 0 ? 0 : Math.min(this.progress, 100);
    const offset = this.circumference - (p / 100) * this.circumference;
    this.dashOffset = offset;
  }
}
